<div [formGroup]="formGroup">
  <div class="flex flex-row flex-wrap gap-2 px-4">
      @if (displayShipmentDate$ | async) {
        <mat-form-field class="flex-auto">
            <mat-label i18n>Shipping Date</mat-label>
            <input matInput formControlName="shipmentDate" [matDatepicker]="shipmentDatePicker" (dateChange)="userChange()">
            <mat-datepicker-toggle matSuffix [for]="shipmentDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #shipmentDatePicker></mat-datepicker>
        </mat-form-field>
      }
    @if (thirdPartyAccountAllowed$ | async) {
      <mat-form-field class="flex-auto">
        <mat-label i18n>Payment</mat-label>
        <mat-select formControlName="paymentOption" (selectionChange)="userChange()">
          <mat-option [value]="paymentOptionEnum.ACCOUNT" i18n>My Account</mat-option>
          <mat-option [value]="paymentOptionEnum.THIRD_PARTY" i18n>Third-Party Account</mat-option>
        </mat-select>
      </mat-form-field>
    }
    @if (thirdPartyAccountActive$ | async) {
      <mat-form-field class="flex-auto" floatLabel="always">
        <mat-label i18n>Bill To Account</mat-label>
        @if (!(thirdPartyAccountSelector$ | async)) {
          <input matInput formControlName="paymentAccountNumber" (change)="userChange()">
        }
        @if (thirdPartyAccountSelector$ | async) {
          <mat-select formControlName="paymentAccountNumber" (selectionChange)="userChange()">
            @for (choice of thirdPartyAccountChoices$ | async; track choice) {
              <mat-option [value]="choice.number">
                {{ choice.label }}
              </mat-option>
            }
          </mat-select>
        }
      </mat-form-field>
    }
    @if (displaySignatureOption$ | async) {
      <mat-form-field class="flex-auto" floatLabel="always">
          <mat-label i18n>Signature Option</mat-label>
          <mat-select formControlName="signatureOption">
              <mat-option [value]="signatureOptionEnum.DEFAULT">Carrier Default</mat-option>
              <mat-option [value]="signatureOptionEnum.REQUIRED">Signature Required</mat-option>
              <mat-option [value]="signatureOptionEnum.NOT_REQUIRED">No Signature</mat-option>
              <mat-option [value]="signatureOptionEnum.ADULT">Adult Signature</mat-option>
          </mat-select>
      </mat-form-field>
    }
  </div>
    @if ((selectedOptions$ | async).length) {
        <div class="flex-column">
            @for (option of selectedOptions$ | async; track option; let optionIndex = $index) {
                <div class="option">
                    <div class="option-row flex flex-row px-2">
                        <app-courier-option-editor [option]="option" class="w-full"></app-courier-option-editor>
                    </div>
                    <mat-divider></mat-divider>
                </div>
            }
        </div>
    } @else {
        <div class="no-options text-center p-2 mx-3">
            <span i18n>No options selected.  Click Select Options to add one.</span>
        </div>
    }
  <div class="text-right p-2">
    <button matButton (click)="addOption()" [disabled]="disabled">
      <span i18n>Select Options</span>
    </button>
  </div>
</div>
